import React from 'react';
import Head from 'next/head';
import LandingPageLayout from 'components/LandingPageLayout';
import RentalMontReal from 'components/v1-tailwindcss/RentalMontReal';
import GrowYourCareer from 'components/v1-tailwindcss/GrowYourCareer';
import WhatOtherSay from 'components/v1-tailwindcss/WhatOtherSay';
import WrapHeadingSection from 'components/v1-tailwindcss/WrapHeadingSection';

export default function RentInMontreal() {
  const pageTitle =  "Apartments for rent in Montreal | Soulrooms";
  const pageDescription =  "Find the apartments for rent in the heart of downtown Montreal. To learn more about our rentals click here.";
  return (
    <>
      <Head>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/tailwindcss/2.2.19/tailwind.min.css"></link>
          <title>{pageTitle}</title>
          <meta name="og:title" content={pageTitle} />
          <meta name="twitter:title" content={pageTitle} />
          <meta name="description" content={pageDescription}/>
          <meta name="og:description" content={pageDescription} />
          <meta name="twitter:description" content={pageDescription} />
      </Head>
      <LandingPageLayout>
        <div className='container mx-auto lg:px-4 px-6'>
          <RentalMontReal
            imgSrc="/static/images/landingPages/RentInMontreal/rent-in-montreal1.webp"
            title="TAILORED REsidences FOR YOUNG PROFESSIONALS "
            para1="Curated properties from the best landlords in the city of Montreal that suit the needs of professionals working in the city as well as students studying at McGill University."
            locNone="hidden"
            para2PY="py-2"
            btn_text="Find Properties Here"
            link="#JotFormIFrame-91797058303261"

          />
          <GrowYourCareer />
          <WrapHeadingSection headTitle="FILL IN YOUR REQUIREMENTS & SEE AVAILABLE OPTIONS">
            <iframe
              id="JotFormIFrame-91797058303261"
              title="Find a SoulRoom"
              onload="window.parent.scrollTo(0,0)"
              allowtransparency="true"
              allowfullscreen="true"
              allow="geolocation; microphone; camera"
              src="https://form.jotform.com/91797058303261"
              frameborder="0"
              style={{ minWidth: '100%', height: '640px', border: 'none', scrolling: 'no' }}></iframe>
          </WrapHeadingSection>
          
          
          {/* <WhatsAppAboutus/> */}
        </div>
          {/* <WhatOtherSay
            title="What others have to say?"
            num="3.9"
            para1="SoulRooms Inc."
            para2="26 Reviews"
          /> */}
      </LandingPageLayout>
    </>
  );
}
